import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { DatePickerProvider, ToastProvider } from '@ntconsult/aluma-react';
import App from './App';
import { queryClient } from './config/queryClient';
import { ErrorBoundary } from './common/components/ErrorBoundary';
import { RateLimitToaster } from './common/components/RateLimitToaster';
import './config/i18n';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <NuqsAdapter>
        <QueryClientProvider client={queryClient}>
          <ToastProvider position="top-right" defaultDuration={4000}>
            <DatePickerProvider>
              <ErrorBoundary>
                <RateLimitToaster />
                <App />
              </ErrorBoundary>
            </DatePickerProvider>
          </ToastProvider>
        </QueryClientProvider>
      </NuqsAdapter>
    </BrowserRouter>
  </React.StrictMode>
);
